module.exports = __webpack_public_path__ + "static/media/closeButton.09df2f3b.svg";